module.exports = __webpack_public_path__ + "img/PS-J-10.f36cda46.svg";